import React, { type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

import { messages } from '../i18n/messages.ts';

import { templateStyles } from './styles.ts';

const EmptyDatabase: FunctionComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={348} height={142} fill="none">
      <rect
        width={336}
        height={141.98}
        x={0.25}
        fill={templateStyles['background']}
        rx={3}
      />
      <rect
        width={335.69}
        height={141.67}
        x={0.41}
        y={0.15}
        stroke="#0B1228"
        strokeOpacity={0.14}
        strokeWidth={0.31}
        rx={2.85}
      />
      <mask id="empty-a" fill="#fff">
        <path d="M.25 0h112v16H.25V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112.25 16v.31h.31V16h-.31Zm0-16h-.31v16h.62V0h-.31Zm0 16v-.31H.25v.62h112V16Z"
        mask="url(#empty-a)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M9.9 6.6H5.53v-.47h4.35v.47Zm0 1.63H5.53v-.46h4.35v.46ZM7.71 9.87H5.54V9.4h2.18v.47Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={12.69} y={9.16}>
          {formatMessage(messages['templates-preview.text-field'])}
        </tspan>
      </text>
      <mask id="empty-b" fill="#fff">
        <path d="M.25 16h112v36.66H.25V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112.25 52.66v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V16h-.31Zm0 36.66v-.31H.25v.62h112v-.31Z"
        mask="url(#empty-b)"
      />
      <mask id="empty-c" fill="#fff">
        <path d="M.25 52.66h112v36.66H.25V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112.25 89.32v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V52.66h-.31Zm0 36.66v-.31H.25v.62h112v-.31Z"
        mask="url(#empty-c)"
      />
      <mask id="empty-d" fill="#fff">
        <path d="M.25 89.32h112v36.66H.25V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M112.25 125.98v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V89.32h-.31Zm0 36.66v-.31H.25v.62h112v-.31Z"
        mask="url(#empty-d)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M6.82 132.67a.26.26 0 0 0-.52 0v1.05H5.24a.26.26 0 0 0 0 .52H6.3v1.05a.26.26 0 0 0 .52 0v-1.05h1.05a.26.26 0 0 0 0-.52H6.82v-1.05Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={3.68}
        letterSpacing={-0.02}
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={10.76} y={135.29}>
          {formatMessage(messages['templates-preview.add-entry'])}
        </tspan>
      </text>
      <mask id="empty-e" fill="#fff">
        <path d="M112.25 0h112v16h-112V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.25 16v.31h.31V16h-.31Zm-.31-16v16h.62V0h-.62Zm.31 15.69h-112v.62h112v-.62Z"
        mask="url(#empty-e)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M119.52 6a.62.62 0 0 1 .44-.18h1.31c.35 0 .63.28.63.62v1.32c0 .17-.07.32-.19.44l-1.78 1.8a.62.62 0 0 1-.89 0l-1.31-1.32a.62.62 0 0 1 0-.88l1.79-1.8Zm.44.29a.16.16 0 0 0-.11.04l-1.8 1.8a.16.16 0 0 0 0 .21l1.33 1.32c.06.06.15.06.22 0l1.78-1.79a.16.16 0 0 0 .05-.1V6.43a.16.16 0 0 0-.16-.15h-1.31Z"
        clipRule="evenodd"
      />
      <path
        fill={templateStyles['icon']}
        d="M120.34 7.07a.31.31 0 1 1 .62 0 .31.31 0 0 1-.62 0Z"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={124.7} y={9.16}>
          {formatMessage(messages['templates-preview.tag-field'])}
        </tspan>
      </text>
      <mask id="empty-f" fill="#fff">
        <path d="M112.25 16h112v36.66h-112V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.25 52.66v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V16h-.31Zm0 36.66v-.31h-112v.62h112v-.31Z"
        mask="url(#empty-f)"
      />
      <mask id="empty-g" fill="#fff">
        <path d="M112.25 52.66h112v36.66h-112V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.25 89.32v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V52.66h-.31Zm0 36.66v-.31h-112v.62h112v-.31Z"
        mask="url(#empty-g)"
      />
      <mask id="empty-h" fill="#fff">
        <path d="M112.25 89.32h112v36.66h-112V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.25 125.98v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V89.32h-.31Zm0 36.66v-.31h-112v.62h112v-.31Z"
        mask="url(#empty-h)"
      />
      <mask id="empty-i" fill="#fff">
        <path d="M224.25 0h109a3 3 0 0 1 3 3v13h-112V0Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M224.25 0h112-112Zm112.31 16.31H224.25v-.62h111.69l.62.62ZM224.25 16V0v16Zm109-16a3.31 3.31 0 0 1 3.31 3.31v13l-.62-.62V3c0-1.66-1.2-3-2.69-3Z"
        mask="url(#empty-i)"
      />
      <path
        fill={templateStyles['icon']}
        fillRule="evenodd"
        d="M231.72 5.98a.78.78 0 1 0 0 1.55.78.78 0 0 0 0-1.55Zm-1.25.78a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm-.62 2.8c0-.65.52-1.17 1.17-1.17h1.4c.64 0 1.17.52 1.17 1.17v.62h-.47v-.62a.7.7 0 0 0-.7-.7h-1.4a.7.7 0 0 0-.7.7v.62h-.47v-.62Z"
        clipRule="evenodd"
      />
      <text
        xmlSpace="preserve"
        fill={templateStyles['fontColor']}
        fontFamily={templateStyles['fontHeading']}
        fontSize={4.36}
        fontWeight="bold"
        letterSpacing="0em"
        style={{
          whiteSpace: 'pre'
        }}
      >
        <tspan x={236.7} y={9.16}>
          {formatMessage(messages['templates-preview.user-field'])}
        </tspan>
      </text>
      <mask id="empty-j" fill="#fff">
        <path d="M224.25 16h112v36.66h-112V16Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336.25 52.66v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V16h-.31Zm0 36.66v-.31h-112v.62h112v-.31Z"
        mask="url(#empty-j)"
      />
      <mask id="empty-k" fill="#fff">
        <path d="M224.25 52.66h112v36.66h-112V52.66Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336.25 89.32v.31h.31v-.31h-.31Zm0-36.66h-.31v36.66h.62V52.66h-.31Zm0 36.66v-.31h-112v.62h112v-.31Z"
        mask="url(#empty-k)"
      />
      <mask id="empty-l" fill="#fff">
        <path d="M224.25 89.32h112v36.66h-112V89.32Z" />
      </mask>
      <path
        fill={templateStyles['border']}
        d="M336.25 125.98v-.31h-112v.62h112v-.31Z"
        mask="url(#empty-l)"
      />
      <mask id="empty-m" fill="#fff">
        <path d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      </mask>
      <path fill={templateStyles['background']} d="M320 0h13a3 3 0 0 1 3 3v13h-16V0Z" />
      <path
        fill={templateStyles['border']}
        d="M319.7-.3h13A3.3 3.3 0 0 1 336 3c0-1.5-1.34-2.7-3-2.7h-12.7l-.6-.6ZM336 16.3h-16.3l.6-.6H336v.6Zm-16.3 0V-.3l.6.6v15.4l-.6.6ZM336 0v16V0Z"
        mask="url(#empty-m)"
      />
      <path fill="#fff" fillOpacity={0.01} d="M324.27 4.27h7.47v7.47h-7.47z" />
      <path
        fill={templateStyles['icon']}
        d="M328 5.51c.16 0 .3.12.3.28l.01.03V7.7h1.87a.31.31 0 0 1 .03.62h-1.9v1.87a.31.31 0 0 1-.62.03V8.31h-1.87a.31.31 0 0 1-.03-.62h1.9V5.82c0-.17.14-.3.31-.3Z"
      />
    </svg>
  );
};
export default EmptyDatabase;
